import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/Home/View';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import { initTheme } from './utils/theme';
import Project from './pages/Project/view';
import Read from './pages/Read/View';
import { Auth } from './pages/Auth/View';
import "@flaticon/flaticon-uicons/css/all/all.css";
import { ScrollToTop } from './utils/ScrollToTop';
import BlogHome from '@/pages/Blog/View';
import { FeedBack } from './pages/Feedback/View';
import Navbar from './components/core/Navbar';
import { Footer } from './components/core/Footer';

function App() {
  useEffect(() => {
    initTheme();
  }, []);
  useTranslation();
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Navbar />
      <Routes>
        <Route path='/' element={< Home />} />
        <Route path='/blog' element={< BlogHome />} />
        <Route path='/blog/:slug' element={< Read />} />
        <Route path="/project/:id" element={<Project />} />
        <Route path="/auth" element={<Auth />} />
        <Route path="/feedback" element={<FeedBack />} />
      </Routes>
      <Footer />
    </BrowserRouter>
  );
}

export default App;